'use strict';

const equalHeight = (arrayItems, count) => {
    if (arrayItems === undefined || arrayItems.length <= 0) {
        return;
    }

    arrayItems.height('');

    let maxH = 0;

    if (!count) {
        arrayItems.each(function () {
            const currentH2 = $(this).outerHeight(true);
            if (currentH2 > maxH) {
                maxH = currentH2;
            }
        });

        arrayItems.css('min-height', maxH);
        return;
    }

    const arrays = [];
    while (arrayItems.length > 0) {
        arrays.push(arrayItems.splice(0, count));
    }

    for (let i = 0; i < arrays.length; i += 1) {
        const data = arrays[i];
        maxH = 0;
        for (let j = 0; j < data.length; j += 1) {
            const currentH = $(data[j]).outerHeight(true);
            if (currentH > maxH) {
                maxH = currentH;
            }
        }

        for (let k = 0; k < data.length; k += 1) {
            $(data[k]).css('min-height', maxH);
        }
    }
};

module.exports = equalHeight;
